import { filter, findIndex, find } from 'lodash';

export function currentOverlay(state) {
    if (state.overlays.length === 0) {
        return null;
    }

    return filter(state.overlays, { isActive: true }).pop();
}

export function nextOverlay(state) {
    const overlay = currentOverlay(state);
    const currentIndex = findIndex(state.overlays, overlay);
    return state.overlays[currentIndex + 1];
}

export function prevOverlay(state) {
    const overlay = currentOverlay(state);
    const currentIndex = findIndex(state.overlays, overlay);
    return state.overlays[currentIndex - 1];
}

export function isOverlayActive(state) {
    return (overlayId) => {
        return !!find(state.overlays, { id: overlayId, isActive: true });
    };
}
